<template>
  <div class="occupation-skills-manager">
    <div class="page-header">
      <div>
        <h1>{{ $t('bo.occupationSkills.title') }}</h1>
        <p>{{ $t('bo.occupationSkills.subtitle') }}</p>
      </div>
    </div>

    <!-- Tabs -->
    <div class="tabs">
      <button :class="['tab', activeTab === 'groups' ? 'tab-active' : '']" @click="activeTab = 'groups'">
        {{ $t('bo.occupationSkills.tabGroups') }}
      </button>
      <button :class="['tab', activeTab === 'roles' ? 'tab-active' : '']" @click="activeTab = 'roles'">
        {{ $t('bo.occupationSkills.tabRoles') }}
      </button>
    </div>

    <OccupationGroupsList v-if="activeTab === 'groups'" />
    <OccupationRolesList  v-if="activeTab === 'roles'" />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import OccupationGroupsList from './OccupationGroupsList.vue'
import OccupationRolesList from './OccupationsList.vue'

const activeTab = ref('roles')
</script>

<style scoped>
.occupation-skills-manager { padding: 2rem; }

.page-header { margin-bottom: 1.5rem; }
.page-header h1 { font-size: 1.75rem; font-weight: 700; color: #1f2937; margin: 0 0 0.25rem; }
.page-header p  { color: #6b7280; font-size: 0.875rem; margin: 0; }

.tabs {
  display: flex;
  gap: 0;
  margin-bottom: 1.5rem;
  border-bottom: 2px solid #e5e7eb;
}
.tab {
  padding: 0.75rem 1.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: #6b7280;
  background: none;
  border: none;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  transition: all 0.15s;
}
.tab:hover   { color: #1f2937; }
.tab-active  { color: #3b82f6; border-bottom-color: #3b82f6; }
</style>
